import styles from "./Logo.module.css";

/** The WireVoD mark: four bands of a play triangle. Colour: `--mark-color`. */
export function Mark({ size = 20, className }: { size?: number; className?: string }) {
  return (
    <svg
      viewBox="0 0 85 100"
      width={size * 0.85}
      height={size}
      aria-hidden="true"
      className={[styles.mark, className].filter(Boolean).join(" ")}
    >
      <polygon points="0,0 47.94,28.2 0,28.2" />
      <polygon points="0,31.7 53.89,31.7 76.84,45.2 0,45.2" />
      <polygon points="0,48.7 82.79,48.7 85,50 64.26,62.2 0,62.2" />
      <polygon points="0,65.7 58.31,65.7 0,100" />
    </svg>
  );
}

/** Mark + wordmark, with an optional product suffix (e.g. "Control"). */
export function Logo({ suffix }: { suffix?: string }) {
  return (
    <span className={styles.logo}>
      <Mark />
      <span>WireVoD</span>
      {suffix ? <span className={styles.suffix}>{suffix}</span> : null}
    </span>
  );
}
